import { render, staticRenderFns } from "./Invertir.vue?vue&type=template&id=1f85b5fc&"
import script from "./Invertir.vue?vue&type=script&lang=js&"
export * from "./Invertir.vue?vue&type=script&lang=js&"
import style0 from "./Invertir.vue?vue&type=style&index=0&id=1f85b5fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports